import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { QuotasPage } from '@/features/admin/quotas/quotas-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Quotas et capacité du tenant (porting README #48). */
export const Route = createFileRoute('/$tenant/resources/quotas/')({ component: QuotasRoute });

function QuotasRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="quotas" crumbs={[{ label: t('nav.items.quotas') }]}>
      <QuotasPage tenantId={tenant} />
    </ConsoleShell>
  );
}
